import { useEffect, useRef } from "react";

const PavingCanvas = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h, dpr;
    const mouse = { x: 0.5, y: 0.5 };

    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      const rect = canvas.getBoundingClientRect();
      w = rect.width;
      h = rect.height;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      mouse.x = e.clientX / window.innerWidth;
      mouse.y = e.clientY / window.innerHeight;
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    const cols = 14;
    const rows = 10;
    const bw = 64;
    const bh = 32;

    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      const ox = w / 2 + (mouse.x - 0.5) * 40;
      const oy = h / 2 + (mouse.y - 0.5) * 24;
      const time = t * 0.0006;

      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const isoX = (col - cols / 2) * bw + (row % 2) * (bw / 2);
          const isoY = (row - rows / 2) * bh * 0.55;
          const depth = Math.sin(time + col * 0.5 + row * 0.7) * 7;
          const x = ox + isoX;
          const y = oy + isoY - depth;
          if (x < -bw || x > w + bw || y < -bh || y > h + bh) continue;

          const top = `rgba(42, 47, 58, ${0.55 - row * 0.04})`;
          const edge = `rgba(142, 149, 165, ${0.25 - row * 0.018})`;
          const isAmber = (col * 7 + row * 3) % 23 === 0;

          ctx.beginPath();
          ctx.moveTo(x, y);
          ctx.lineTo(x + bw * 0.92, y);
          ctx.lineTo(x + bw * 0.92, y + bh * 0.6);
          ctx.lineTo(x, y + bh * 0.6);
          ctx.closePath();
          ctx.fillStyle = isAmber ? "rgba(255, 184, 0, 0.85)" : top;
          ctx.fill();
          ctx.strokeStyle = isAmber ? "rgba(255, 184, 0, 0.4)" : edge;
          ctx.lineWidth = 1;
          ctx.stroke();
        }
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return <canvas ref={ref} className="h-full w-full" aria-hidden="true" data-testid="paving-canvas" />;
};

export default PavingCanvas;
